(function () {
  function renderSpecRows(items, rowClass) {
    return items
      .filter(function (item) { return window.hasValue(item.value); })
      .map(function (item) {
        return (
          '<div class="' + rowClass + '">' +
            '<span class="' + rowClass + '__label">' + window.escapeHtml(item.label) + '</span>' +
            '<span class="' + rowClass + '__value">' + window.escapeHtml(item.value) + '</span>' +
          '</div>'
        );
      })
      .join('');
  }

  function formatUnit(value, suffix) {
    return window.hasValue(value) ? value + ' ' + suffix : null;
  }

  function formatDate(value) {
    if (!value) return '-';
    var parts = String(value).split('-');
    return parts.length === 3 ? parts[2] + '.' + parts[1] + '.' + parts[0] : value;
  }

  function formatDrivingSide(value, messages) {
    if (!value) return null;
    if (value === 'HOYRE') return messages.drivingSideRight;
    if (value === 'VENSTRE') return messages.drivingSideLeft;
    return value;
  }

  function renderDetailGroup(title, items) {
    var rows = renderSpecRows(items, 'vehicle-detail-row');
    if (!rows) return '';

    return (
      '<section class="vehicle-detail-group">' +
        '<h3 class="vehicle-detail-group__title">' + window.escapeHtml(title) + '</h3>' +
        '<div class="vehicle-detail-group__rows">' + rows + '</div>' +
      '</section>'
    );
  }

  window.renderKjoretoyPopupDetails = function (vehicle, messages) {
    var html = '';

    html += renderDetailGroup(messages.groupCarInfo, [
      { label: messages.vin, value: vehicle.vin },
      { label: messages.type, value: vehicle.typeDesignation },
      { label: messages.variant, value: vehicle.variant },
      { label: messages.vehicleClass, value: vehicle.technicalVehicleClass },
      { label: messages.registrationStatus, value: vehicle.registrationStatus }
    ]);

    html += renderDetailGroup(messages.groupTechnical, [
      { label: messages.engineCode, value: vehicle.engineCode },
      { label: messages.power, value: formatUnit(vehicle.maxNetPowerKw, 'kW') },
      { label: messages.maxSpeed, value: formatUnit(vehicle.maxSpeedKph, 'km/t') },
      { label: messages.drive, value: vehicle.drivetrain },
      { label: messages.drivingSide, value: formatDrivingSide(vehicle.drivingSide, messages) }
    ]);

    html += renderDetailGroup(messages.groupBody, [
      { label: messages.body, value: vehicle.bodyType },
      { label: messages.color, value: vehicle.color },
      { label: messages.doors, value: vehicle.numberOfDoors },
      { label: messages.seats, value: vehicle.seatsTotal }
    ]);

    html += renderDetailGroup(messages.groupDimensions, [
      { label: messages.length, value: formatUnit(vehicle.lengthMm, 'mm') },
      { label: messages.width, value: formatUnit(vehicle.widthMm, 'mm') },
      { label: messages.height, value: formatUnit(vehicle.heightMm, 'mm') },
      { label: messages.wheelbase, value: formatUnit(vehicle.wheelbaseMm, 'mm') },
      { label: messages.weight, value: formatUnit(vehicle.curbWeightKg, 'kg') },
      { label: messages.totalWeight, value: formatUnit(vehicle.maxPermittedTotalWeightKg, 'kg') }
    ]);

    html += renderDetailGroup(messages.groupRegistration, [
      { label: messages.firstReg, value: formatDate(vehicle.firstRegistrationDate) },
      { label: messages.lastApproved, value: formatDate(vehicle.lastApprovedInspectionDate) },
      { label: messages.eu, value: formatDate(vehicle.euControlDeadline) }
    ]);

    return html || '<p class="vehicle-drawer__empty">' + window.escapeHtml(messages.noDetails || '') + '</p>';
  };
})();